import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { fromEvent, Subscription } from 'rxjs';
import { debounceTime, first, filter, take } from 'rxjs/operators';
import { CustomerModel } from 'src/app/models/customer-model';
import { isUndefined } from 'src/app/services/codeUtils';
import { ConfigService } from 'src/app/services/config/config.service';
import { EventsService } from 'src/app/services/event/event.service';
import { GameHub } from 'src/app/services/gameHub/game-hub';
import { GameHubControllerService } from 'src/app/services/gameHub/game-hub-controller';
import { TimeService } from 'src/app/services/time-service/time.service';


import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { WebservicesService } from 'src/app/services/webservices/webservices.service';
import { Navigator } from '../../services/routing/navigator';
import { Platform } from '@ionic/angular';
import { SafeArea } from "capacitor-plugin-safe-area";
import { ScreenOrientation } from "@awesome-cordova-plugins/screen-orientation/ngx";
import { RoutingService } from 'src/app/services/routing/routing.service';
import { MobileToolsService } from 'src/app/services/mobile-tools/mobile-tools.service';
import { GameTileService } from 'src/app/services/game-tile/game-tile.service';
import { Device } from '@awesome-cordova-plugins/device/ngx';

@Component({
  selector: 'app-game',
  templateUrl: './game.component.html',
  styleUrls: ['./game.component.scss'],
})
export class GameComponent implements OnInit, AfterViewInit, OnDestroy {
  public showRecentPlayedGames: boolean;
  public game_height: object = {};
  public show: boolean = true;
  public timeOnlineEnabled: boolean;
  public showTimeOnline: boolean;
  public showNetPosition: boolean;
  public isMobile: boolean;
  public isMobileOrMobileWeb: boolean;
  public isMobileWeb: boolean;
  public isCordova: boolean;
  public isCapacitor: boolean;
  public isIOSApp: boolean;
  public isIOSWeb: boolean = false;
  public windowResizeSubscription: Subscription;
  public instanceId: string;
  public showPreloader: boolean = true;
  public onlineTimeInterval: ReturnType<typeof setInterval>;
  public timeOnline: string;
  public gameURL: SafeResourceUrl;
  public showMyGamesPane: boolean = true;
  public customer: CustomerModel;
  public isAuthenticated: boolean;
  public isDemoGame: boolean = false;
  public backButtonSubscribtion: Subscription;
  public dataToDisplay: string;
  public netPositionDelay: any;
  public netWinOperator: string = "+";
  public netWinAmount: string = '0.00';
  public isClosed: boolean = false;
  public timeServiceSubscription: any;
  private userSubscription: any;
  public insets: any;
  public gameType;
  public notifyCustomerRotate: boolean = false;
  private restartGameRequest: boolean = false;
  public showLastPlayedForLD: boolean;
  private subscr: Array<Subscription> = [];
  public isAndroid15OrAbove: boolean = false;

  constructor(
    private config: ConfigService,
    private eventsService: EventsService,
    private gameHubService: GameHub,
    private gameTile: GameTileService,
    private platform: Platform,
    private mobileTools: MobileToolsService,
    private sanitizer: DomSanitizer,
    private screenOrientation: ScreenOrientation,
    private timeService: TimeService,
    private userSessionService: UserSessionService,
    private gameHubControllerService: GameHubControllerService,
    private navigator: Navigator,
    private webservices: WebservicesService,
    private routing: RoutingService,
    private device: Device,
  ) {
    this.userSessionService
      .getCustomerSubscription()
      .then((customerSubject) =>
        this.subscr.push(customerSubject.subscribe((customer) => {
          this.customer = customer;
        })
        ));

    this.isAuthenticated = userSessionService.isAuthenticated()
    this.isAndroid15OrAbove = this.platform.is('capacitor') && this.platform.is('android') &&
      parseInt((device && device.version) || '0', 10) >= 15;
    this.backButtonSubscribtion = platform.backButton.subscribeWithPriority(101, () => {
      console.log("game component: backButton subscribeWithPriority")
      this.onCloseBtn();
    });

    this.netPositionDelay = this.config.getConfig().FEATURE_NET_POSITION_DELAY || '0';
    this.subscr.push(this.eventsService.subscribe('event:GameStats:Response', (data) => {
      console.log('-----received-------', data)
      this.dataToDisplay = data;
      let timeout = 0;
      if (this.netPositionDelay) {
        if (this.netPositionDelay == 0) {
          timeout = 0;
        } else {
          timeout = this.netPositionDelay * 1000;
        }
      }
      //configurable delay to display Net Position on UI
      setTimeout(() => {
        if (this.dataToDisplay.startsWith('-')) {
          this.netWinOperator = "-";
          this.netWinAmount = this.dataToDisplay.substring(1);
        } else {
          this.netWinOperator = "+";
          this.netWinAmount = this.dataToDisplay;
        }
        console.log('-----displaying-----', this.netWinAmount)
      }, timeout);
      //After displaying netWinAmount remove the previousValue, So we have alway one value which will be previousValue based on logic.
      //this.netPosition.shift();
      //console.log('-----stored-----', this.netPosition)
    }));
    this.messageEventListener = this.messageEventListener.bind(this);
    this.fullscreenchange = this.fullscreenchange.bind(this);

    this.subscr.push(this.eventsService.subscribe('notification:end:game:session', () => {
      this.onCloseBtn();
    }));
  }

  ngOnInit() {
    this.showLastPlayedForLD = this.config.getConfig().FEATURE_SHOW_LAST_PLAYED_ON_LD_LAUNCH === '1' ? true : false;
    this.subscr.push(this.eventsService.subscribe("event:notifyCustomerRotate:end", () => {
      this.notifyCustomerRotate = false;
    }));
    this.notifyCustomerRotate = this.gameHubControllerService.shouldNotifyCustomerRotate;
    if (this.isMobileOrMobileWeb) {
      this.showTimeOnline = this.config.getConfig().FEATURE_SHOW_TIME_ONLINE && (this.config.getConfig().FEATURE_SHOW_TIME_ONLINE === "0") ? false : true;
    }

    this.showNetPosition = this.config.getConfig().FEATURE_SHOW_NET_POSITION ?? 0;

    // this.setPlatforms is called from games component
    this.onWindowResize();
    this.isIOSWeb = this.platform.is("ios") && this.platform.is("mobileweb");
    setTimeout(() => {
      this.showPreloader = false;
    }, 1000);

    document.addEventListener('fullscreenchange', this.fullscreenchange);

    window.addEventListener('message', this.messageEventListener, false);

    if (this.showTimeOnline) {
      this.initializeTimeOnline();
    }
    this.subscr.push(this.eventsService.subscribe("game:fullscreen:exit", () => {
      this.toggleFullScreen(true);
    }));
    this.subscr.push(this.eventsService.subscribe("game:confirm:start", () => {
      let keywordsComponent = document.getElementsByTagName('app-site-header')[0];
      if (!!keywordsComponent && (this.platform.is("mobileweb") || this.platform.is("capacitor")))
        keywordsComponent.setAttribute('style', 'display:none');
    }));
    setTimeout(() => {
      this.setPlaceholderHeight();
    }, 500)
  }

  //After Game Componenet is created and view becomes visible set the game Height
  ngAfterViewInit() {
    setTimeout(() => {
      this.setPlaceholderHeight();
    }, 1000);
  }

  ngOnDestroy() {
    clearInterval(this.onlineTimeInterval);
    this.onlineTimeInterval = null;
    if (this.timeServiceSubscription) { this.timeServiceSubscription.unsubscribe(); }
    if (this.userSubscription) { this.userSubscription.unsubscribe(); }
    this.isClosed = true;
    this.gameCloseService();
    if (this.windowResizeSubscription) {
      this.windowResizeSubscription.unsubscribe();
    }
    if (this.backButtonSubscribtion) {
      this.backButtonSubscribtion.unsubscribe();
    }
    if (this.restartGameRequest) {
      this.eventsService.publish("event:game:restart");
    }
    document.removeEventListener('fullscreenchange', this.fullscreenchange);
    window.removeEventListener('message', this.messageEventListener, false);
    this.subscr.forEach(s => s.unsubscribe());

  }

  fullscreenchange() {
    if (!document.fullscreenElement) {
      this.clearMobileLook();
      console.log('Leaving full-screen mode.');
    }
  }

  ionViewDidEnter() {
    this.onWindowResize();
    setTimeout(() => {
      this.setPlaceholderHeight();
    }, 0)
  }

  ionViewWillLeave() {
    console.log('view will leave');
    if (this.isMobile) {
      this.clearMobileLook();
    }

    if (!!this.windowResizeSubscription)
      this.windowResizeSubscription.unsubscribe();

    this.gameHubService.muteAllGames();
    this.gameHubService.unfocusInstance(this.instanceId);
  }

  private onWindowResize = () => {
    if (!!this.windowResizeSubscription)
      this.windowResizeSubscription.unsubscribe();
    this.windowResizeSubscription = fromEvent(window, 'resize').pipe(debounceTime(100)).subscribe(
      (event) => {
        // add debounce 100 ms

        this.setPlaceholderHeight();
        setTimeout(() => this.iframePostMessage('IAB_WINDOW_RESIZE'), 1000);
      }
    );
  };

  private getVendorEventDataFormat(data: string) {
    if (this.isMobileOrMobileWeb) {
      //Sending event directly to the vendor page
      return { message: data };
    } else {
      //Sending event to the our external game load page and then vendor
      return { recipient: "vendor", messageData: { message: data } };
    }
  }

  private iframePostMessage(message: string) {
    const data = this.getVendorEventDataFormat(message);
    let iframe = this.getIframe();
    if (iframe) {
      iframe.postMessage(data, '*');
      console.log("message sent: ", data);
    }
  }

  private getIframe() {
    let elem = document.getElementById('iframe_' + this.instanceId) as HTMLIFrameElement;
    let iframe = elem?.contentWindow;
    return iframe;
  }

  private messageEventListener(event) {
    if (!isUndefined(event.data)) {
      this.handleGameEvents(event.data);
    }
  }

  private handleGameEvents(eventData) {
    try {
      const data = (typeof eventData === 'object') ? eventData : JSON.parse(eventData);
      console.log(':::handleGameEvents:::', data)
      if (data && data.message) {
        console.log(':::handleGameEvents:::', data.message)
        switch (data.message) {
          case "rgs2custReloadGame":
          case "rgs2custReloadGameInProgress":
            this.restartGameRequest = true;
            this.onCloseBtn();
            break;
          case "end_game_session":
            this.onCloseBtn();
            break;
        }
      }

      /*if (data && data._type === "nw2Lobby.closegame.CloseGameResponse") {
        if (!this.isClosed) {
          this.gameCloseService();
        }
      }
      if(data && (data.message == "rgs2custReloadGame" || data.message == "rgs2custReloadGameInProgress")) {
        this.restartGameRequest = true;
        this.onCloseBtn();
      }*/
    } catch (error) {
      console.log("handleGameEvents Error: ", error)
    }
  }

  public setPlaceholderHeight() {
    if (this.isMobileOrMobileWeb) {
      this.setMobileLook();
    } else {

      const topGameNavigationButtonElement: any = document.querySelector("ion-col.game-wrapper-bar");
      console.log('topGameNavigationButtonElement ----', topGameNavigationButtonElement)
      const topGameNavigationButtonHeight: any = !!topGameNavigationButtonElement ? topGameNavigationButtonElement.offsetHeight : 50;
      console.log('topGameNavigationButtonHeight ----', topGameNavigationButtonHeight);
      const headerElement: any = document.querySelector("app-navbar");
      console.log('headerElement ----', headerElement)
      let headerHeight: any = !!headerElement ? headerElement.offsetHeight : 0;

      const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
      if (isSafari) {
        const headerElementParent: any = document.querySelector("#ts-site-navbar");
        if (headerHeight === 0 && headerElementParent?.offsetHeight > 0) {
          headerHeight = headerElementParent.offsetHeight;
        }
      }

      const catbarElement: any = document.querySelector("app-catbar");
      const catbarHeight: any = !!catbarElement ? catbarElement.offsetHeight : 0;
      console.log('catbarHeight ----', catbarElement)

      const isIpadPortrait = this.platform.is('ipad') && this.isCapacitor && this.platform.isPortrait(); // changing the padding if ipad portrait
      //Adding 10px to adjust extra padding which i have to figure out for style so, don't have to use fixed value
      const height =
        window.innerHeight - headerHeight - topGameNavigationButtonHeight - catbarHeight - (isIpadPortrait ? 36 : 10);
      console.log('window.innerHeight ----', window.innerHeight)
      console.log('height ----', height)
      this.game_height = { height: `${height}px` };
    }
    const TIME_OUT_SET_CSS = this.platform.is('ios') && this.platform.is('capacitor') ? 500 : 10
    setTimeout(() => {
      if (!this.platform.is('ios') && !this.isAndroid15OrAbove) {
        this.changeCssToAvoidBrowserLoadingBug();
      }
    }, TIME_OUT_SET_CSS);
  }

  changeCssToAvoidBrowserLoadingBug() {
    let tabbar = document.querySelector('body');
    let q = 100;
    let x = setInterval(() => {
      if (!this.isClosed) {
        if (!!tabbar) tabbar.setAttribute('style', `max-width: ${q}%`);
        q = q == 100 ? 101 : 100;
      } else {
        clearInterval(x);
      }
    }, 100);

    setTimeout(() => {
      clearInterval(x);
    }, 3000);
  }

  showGame(show: boolean) {
    this.show = show;
  }

  setInstanceId(instanceId) {
    console.log(instanceId);

    this.instanceId = instanceId;
  }

  setGameUrl(url, session_token, isDemo, gameType?) {
    if (!session_token || isDemo) {
      this.gameURL = this.sanitizer.bypassSecurityTrustResourceUrl(url + '&windowID=' + this.instanceId);
      this.showRecentPlayedGames = false;
    } else {
      this.showRecentPlayedGames = this.config.getConfig().FEATURE_SHOW_RECENT_PLAYED_ON_GAME_PAGE ?? 0;

      const deviceType = this.gameHubControllerService.getDeviceType();
      if (gameType) this.gameType = gameType;
      const obj: any = {
        session_token: session_token
      }
      this.webservices.getApiNoRedirect(url, deviceType, obj).pipe(first()).subscribe(
        resp => {
          if (!!resp.result && resp.payload) {
            this.gameTile.waitingGameData = null;
            let url = '';
            if ('href' in resp.payload) url = resp.payload.href;
            if ('src' in resp.payload) url = resp.payload.src;
            if (this.isCapacitor || this.isMobileOrMobileWeb) setTimeout(() => this.eventsService.publish("event:bottommenu:hide"), 100);
            this.gameURL = this.sanitizer.bypassSecurityTrustResourceUrl(url + '&windowID=' + this.instanceId);
          }
        }, error => {
          console.log("Error occurred:", error.error_code);
          if (error.error_code === "PLAYER_HAS_ACTIVE_BONUS_CANNOT_USED_BY_GAME") {
            localStorage.setItem('skipActiveBonusCheck', 'true');
            this.onCloseBtn();
            setTimeout(() => {
              this.navigator.openPopover(
                'RestrictedMoneyPopover',
                { message: '' },
                'standard-popover levelup',
                false,
                true,
                true,
                -1,
                'cover',
                true
              );

            }, 700);
          }
        }
      )
    }
  }

  public setPlatforms(platforms) {
    this.isMobile = platforms.isMobile;
    this.isMobileOrMobileWeb = platforms.isMobileOrMobileWeb;
    this.isMobileWeb = platforms.isMobileWeb;
    this.isCordova = platforms.isCordova;
    this.isCapacitor = platforms.isCapacitor;
    this.isIOSApp = platforms.isIOSApp;
  }

  toggleFullScreen(exit: boolean = false) {
    var doc: any = window.document;
    var docEl: any = doc.documentElement;
    var requestFullScreen =
      docEl.requestFullscreen ||
      docEl.mozRequestFullScreen ||
      docEl.webkitRequestFullScreen ||
      docEl.msRequestFullscreen;
    var cancelFullScreen =
      doc.exitFullscreen ||
      doc.mozCancelFullScreen ||
      doc.webkitExitFullscreen ||
      doc.msExitFullscreen;

    if (!!exit) {
      this.clearMobileLook();
      if (
        doc.fullscreenElement ||
        doc.webkitFullscreenElement ||
        doc.mozFullScreenElement
      ) {
        cancelFullScreen.call(doc).catch((error) => {
          console.log(error);
        });
        // can use exitFullscreen
      }

      return false;
    }
    if (
      !doc.fullscreenElement &&
      !doc.mozFullScreenElement &&
      !doc.webkitFullscreenElement &&
      !doc.msFullscreenElement
    ) {
      this.showRecentPlayedGames = false;
      this.setMobileLook();
      requestFullScreen.call(docEl);
    } else {
      this.showRecentPlayedGames = this.config.getConfig().FEATURE_SHOW_RECENT_PLAYED_ON_GAME_PAGE ?? 0;
      this.clearMobileLook();
      cancelFullScreen.call(doc);
    }
  }

  private clearMobileLook() {
    let scrollContent = document.querySelector('app-game');
    let topHeaderEl: any = document.querySelector('ion-toolbar');
    let keywordsComponent = document.getElementsByTagName('app-site-header')[0];

    if (!!keywordsComponent)
      keywordsComponent.setAttribute('style', 'display:block');

    let lastPlayed = document.getElementById('my_games');
    if (!!lastPlayed)
      lastPlayed.setAttribute('style', 'display:block;padding-top: 0px; padding-bottom: 0px; flex: 0 0 calc(calc(2 / var(--ion-grid-columns, 12)) * 100%); width: calc(calc(2 / var(--ion-grid-columns, 12)) * 100%); max-width: calc(calc(2 / var(--ion-grid-columns, 12)) * 100%);');


    if (!!scrollContent)
      scrollContent.setAttribute('style', 'overflow-y: auto;');
    if (!!topHeaderEl) topHeaderEl.setAttribute('style', 'display:block');
    this.showMyGamesPane = true;
  }
  public adjustStyleForNotch() {
    let gameWholeAreaElement: any = document.querySelector(".game-whole-area");
    if (!!gameWholeAreaElement && this.platform.is("ios") && this.platform.isLandscape()) {
      gameWholeAreaElement.setAttribute('style', 'padding-left:40px');
    } else {
      gameWholeAreaElement.setAttribute('style', 'padding-left:unset');
    }
  }
  public setMobileLook() {
    // let topHeaderEl: any = document.querySelector('ion-toolbar');
    let tabbar = document.querySelector('.tabbar');
    let scrollContent = document.querySelector('games-home .scroll-content');
    let keywordsComponent = document.getElementsByTagName('app-site-header')[0];

    let lastPlayed = document.getElementById('my_games');
    if (!!lastPlayed)
      lastPlayed.setAttribute('style', 'display:none');
    let gameBarElement: any = document.querySelector(
      'ion-row.control-bar-reversed-columns'
    );
    let gameBarHeight: any = !!gameBarElement ? gameBarElement.offsetHeight : 0;
    let topGameNavigationButtonElement: any = document.querySelector("ion-col.game-wrapper-bar");
    let topGameNavigationButtonHeight: any = !!topGameNavigationButtonElement ? topGameNavigationButtonElement.offsetHeight : 50;
    console.log('topGameNavigationButtonHeight ----', topGameNavigationButtonHeight);
    if (!!keywordsComponent && !(this.platform.is("mobileweb") || this.platform.is("capacitor")))
      keywordsComponent.setAttribute('style', 'display:none');
    if (this.platform.is("ios")) {
      this.adjustStyleForNotch();
      this.subscr.push(this.screenOrientation.onChange().subscribe(
        () => {
          this.adjustStyleForNotch();
        }
      ));
    }
    // if (!!topHeaderEl) topHeaderEl.setAttribute('style', 'display:none');
    if (!!tabbar) tabbar.setAttribute('style', 'display:none');
    this.showMyGamesPane = false;
    if (!!gameBarElement) gameBarElement.setAttribute('style', 'display:none');
    if (!!scrollContent) {
      scrollContent.setAttribute('style', 'overflow-y: hidden;');
      scrollContent.setAttribute('style', 'margin-top: 0!important;');
    }
    //Adding 500ms delay so, when phone is roated in landscape view (while game is already running), it will adjust window height properly
    setTimeout(() => {
      let height = window.innerHeight - gameBarHeight - topGameNavigationButtonHeight;
      this.game_height = { height: `calc(${height}px - env(safe-area-inset-bottom) ${this.isIOSApp || this.isAndroid15OrAbove ? '- env(safe-area-inset-top)' : '- 10px'})` };
    }, 500);
    window.scrollTo(0, 0);
  }

  onCloseBtn() {
    this.routing.defaultRoute();
    this.isClosed = true;
    this.gameCloseService();
  }

  private gameCloseService() {
    if (this.isClosed) {
      this.iframePostMessage('CLOSE_GAME');
    }

    if (this.isMobile) {
      setTimeout(() => this.eventsService.publish("event:bottommenu:show"), 200);
    }
    //if (this.isMobile) {
    this.eventsService.publish("event:empty:gamedata"); // to set empty live dealer game
    //}
    // Only call close-game API if we have customer and session data (not demo mode)
    if (this.customer?.customerId && this.userSessionService?.getSessionToken()) {
      const obj: any = {
        customer_id: this.customer.customerId,
        session_token: this.userSessionService.getSessionToken(),
        game_launcher_id: "-1",
      };
      this.webservices.post("games/close-game", obj).subscribe(() => {
        this.handleGameClosure();
      });
    } else {
      // Demo mode - directly handle closure without API call
      this.handleGameClosure();
    }
  }

  // Separate method for common closure handling
  private handleGameClosure() {
    this.gameHubControllerService.removeInstance(this.instanceId);
    this.eventsService.publish("event:game:close");
    try {
      this.eventsService.publish('event:tracker:gameClosed');
    } catch (e) {
      console.log("Error", e)
    }

    this.eventsService.publish("event:balanceState", { show: true });
    if (this.isCapacitor) {
      if (!!this.windowResizeSubscription)
        this.windowResizeSubscription.unsubscribe();
      this.eventsService.publish("event:bottommenu:show")
    }
    else if (this.isMobileOrMobileWeb) {
      this.eventsService.publish("event:siteheader:show");
    } else {
      this.eventsService.publish("event:bottommenu:show")
    }
    window.removeEventListener('message', this.messageEventListener);
    if (this.platform.is("ios")) {
      this.applySafeArea();
    }
  }

  async applySafeArea() {
    setTimeout(async () => {
      this.insets = await SafeArea.getSafeAreaInsets();
      this.mobileTools.insets = this.insets;
      this.createSafeArea();
      document.body.style.backgroundColor = "black";
      this.checkOrientationAndAdjust();
    }, 100);
  }

  createSafeArea() {
    document.documentElement.style.setProperty(
      "--sab",
      `${this.insets.insets.bottom}px`
    );
    document.documentElement.style.setProperty(
      "--sat",
      `${this.insets.insets.top}px`
    );
    document.documentElement.style.setProperty(
      "--sar",
      `${this.insets.insets.right}px`
    );
    document.documentElement.style.setProperty(
      "--sal",
      `${this.insets.insets.left}px`
    );
    //  console.log("<------ Sizing Almighty --- Custom Style Baby -------->",document.documentElement.style);
  }

  checkOrientationAndAdjust() {
    document.body.style.height = `calc(100% - ${this.insets.insets.top}px)`;
    document.documentElement.style.marginTop = `${this.insets.insets.top}px`;
  }

  private timeFunction(currentLoginTime) {
    return new Promise((resolve, reject) => {
      if (this.timeServiceSubscription) {
        this.timeServiceSubscription.unsubscribe();
      }
      this.timeServiceSubscription = this.timeService.callTime().subscribe(
        (currentTime) => {
          let currentTimeTS
          if (currentTime.result == 1) {
            let createDate = new Date(currentLoginTime);
            const firstLoginTime = Date.parse(String(createDate));
            currentTimeTS = currentTime.payload.ts;
            const serverTime = currentTime.payload.full;
            let loggedInTime = firstLoginTime || currentTimeTS;
            if (currentLoginTime) {
              this.timeOnline = this.timeService.getTimeOnline(currentTimeTS, loggedInTime);
            }
            this.timeService.setOnlineTime(this.timeOnline)
            resolve(0);
          } else {
            console.error('Time service returned an unexpected result.');
            resolve(0);
          }
        },
        (error) => {
          console.error('Error in time service subscription:', error);
          resolve(0);
        }
      );
    });
  }
  private async initializeTimeOnline() {
    const updateOnlineTime = () => {
      this.timeOnline = this.timeService.getOnlineTime() || '';
    };
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }
    this.userSubscription = this.userSessionService.getCustomer().pipe(
      filter(value => value !== undefined),
      take(1)
    ).subscribe((customer: CustomerModel) => {
      if (customer) {
        this.timeFunction(customer.currentLoginTime);
      }
    });
    try {
      this.timeOnline = this.timeOnline || this.timeService.getOnlineTime() || '';
      if (this.onlineTimeInterval) {
        clearInterval(this.onlineTimeInterval);
      }
      this.onlineTimeInterval = setInterval(updateOnlineTime, 30000);

    } catch {
      this.timeOnline = this.timeService.getOnlineTime() || '';
    }
  }
}
